"use client";

import AppImage from "@/components/ui/AppImage";

const GALLERY_IMAGES = [
{ src: "https://img.rocket.new/generatedImages/rocket_gen_img_1761e050a-1768469148243.png", alt: "Open-plan living and dining room renovation with modern minimalist design" },
{ src: "https://images.unsplash.com/photo-1633605015660-b0f2dbad3bf2", alt: "Luxury bedroom with custom headboard and ambient LED lighting" },
{ src: "https://images.unsplash.com/photo-1722604817803-4c88edef9bc0", alt: "Modern kitchen renovation with white marble countertops and integrated appliances" },
{ src: "https://images.unsplash.com/photo-1654694175969-834b8aeddb0e", alt: "Spa bathroom with freestanding bathtub and floor-to-ceiling marble tiles" },
{ src: "https://images.unsplash.com/photo-1722764375892-32aa3e1811da", alt: "Elegant dining room with designer pendant lights and custom furniture" },
{ src: "https://img.rocket.new/generatedImages/rocket_gen_img_1d77a9752-1767196504972.png", alt: "Open-plan office renovation with collaborative zones and natural light" },
{ src: "https://img.rocket.new/generatedImages/rocket_gen_img_18a201090-1764741125375.png", alt: "Custom built-in storage wall with display shelving and TV unit" },
{ src: "https://img.rocket.new/generatedImages/rocket_gen_img_1388ded2e-1768308066610.png", alt: "Master bedroom suite with walk-in wardrobe and accent wall" },
{ src: "https://images.unsplash.com/photo-1682662044630-716bffcc9d25", alt: "Contemporary sofa and living area with marble flooring" },
{ src: "https://images.unsplash.com/photo-1631049035115-f96132761a38", alt: "Hotel-style guest bedroom with custom dressing table and mirrors" }];


export default function GalleryStrip() {
  return (
    <div className="w-full py-4 overflow-hidden" style={{ background: "#0A1628" }}>
      <div className="flex gap-3 overflow-x-auto no-scrollbar px-4">
        {GALLERY_IMAGES?.map((img, i) =>
        <div
          key={i}
          className="relative flex-shrink-0 rounded-xl overflow-hidden group"
          style={{ width: "200px", height: "150px" }}>
          
            <AppImage
            src={img?.src}
            alt={img?.alt}
            fill
            className="object-cover transition-transform duration-700 group-hover:scale-110" />
          
            <div
            className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-300"
            style={{ background: "rgba(212,175,55,0.15)" }} />
          
          </div>
        )}
      </div>
    </div>);

}